<template>
  <b-card
    no-body
    class="p-2"
  >
    <h3 class="mb-2">
      {{ classContract.claseContratoId == 0 ? $t('Routes.ClassContractAdd'): $t('Routes.ClassContractEdit') }}
    </h3>
    <validation-observer
      #default="{ handleSubmit }"
      ref="refFormObserver"
    >
      <b-form
        @submit.prevent="handleSubmit(onSubmit)"
        @reset.prevent="resetForm"
      >
        <b-row>
          <!-- name work area field -->
          <b-col
            cols="12"
          >
            <validation-provider
              #default="{ errors }"
              :name="$t('humanResources.classContract.columns.name')"
              rules="required"
            >
              <b-form-group
                :label="$t('humanResources.classContract.columns.name')"
                :state="errors.length > 0 ? false:null"
              >
                <b-form-input
                  v-model="classContract.nombre"
                />
                <b-form-invalid-feedback :state="errors.length > 0 ? false:null">
                  {{ errors[0] }}
                </b-form-invalid-feedback>
              </b-form-group>
            </validation-provider>
          </b-col>
          <!-- Description Field -->
          <b-col
            cols="12"
          >
            <validation-provider
              #default="{ errors }"
              name="Description"
              rules="required"
            >
              <b-form-group
                :label="$t('humanResources.classContract.columns.description')"
                :state="errors.length > 0 ? false:null"
              >
                <b-form-textarea
                  v-model="classContract.descripcion"
                />
                <b-form-invalid-feedback :state="errors.length > 0 ? false:null">
                  {{ errors[0] }}
                </b-form-invalid-feedback>
              </b-form-group>
            </validation-provider>
          </b-col>
        </b-row>
        <b-row class="float-right mt-2 mb-2">
          <b-button v-ripple.400="'rgba(255, 255, 255, 0.15)'" variant="primary" class="mr-2" type="submit">
            <b-spinner v-if="addingClassContract" small class="mr-1" />
            {{ classContract.claseContratoId == 0 ? $t('Lists.Add'): $t('Lists.Edit') }}
          </b-button>
        </b-row>
      </b-form>
    </validation-observer>
  </b-card>
</template>

<script>
import {
  BCard,
  BForm,
  BRow,
  BCol,
  BFormInput,
  BFormGroup,
  BFormTextarea,
  BSpinner,
  BFormInvalidFeedback,
  BButton,
} from 'bootstrap-vue'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import humanResources from '@/services/humanresources.service'
import { ref } from '@vue/composition-api'
import router from '@/router'
import { required } from '@validations'
import formValidation from '@core/comp-functions/forms/form-validation'

export default {
  components: {
    BCard,
    BForm,
    BRow,
    BCol,
    BFormInput,
    BFormInvalidFeedback,
    BFormGroup,
    BFormTextarea,
    BButton,
    BSpinner,

    ValidationProvider,
    ValidationObserver,
  },
  props: {
    modalCall: {
      type: Boolean,
      require: false,
      default: false,
    },
  },
  setup(props, { emit }) {
    const addingClassContract = ref(false)
    const classContract = ref({
      claseContratoId: 0,
      nombre: '',
      descripcion: '',
      archivado: false,
    })

    const blankClassContract = {
      claseContratoId: 0,
      nombre: '',
      descripcion: '',
      archivado: false,
    }

    const {
      fetchClassContract,
      createClassContract,
      updateClassContract,
    } = humanResources()

    const resetClassContract = () => {
      classContract.value = JSON.parse(JSON.stringify(blankClassContract))
    }

    if (router.currentRoute.params.claseContratoId) {
      fetchClassContract(router.currentRoute.params.claseContratoId, data => {
        classContract.value = data
      })
    } else {
      classContract.value = JSON.parse(JSON.stringify(blankClassContract))
    }
    const {
      refFormObserver,
      getValidationState,
      resetForm,
    } = formValidation(resetClassContract)

    const onSubmit = () => {
      addingClassContract.value = true
      if (classContract.value.claseContratoId === 0) {
        createClassContract(classContract.value, () => {
          addingClassContract.value = false
          if (props.modalCall) {
            emit('find-records')
          } else {
            router.push({ name: 'apps-human-resources-class-contract-list' })
          }
        })
      } else {
        updateClassContract(classContract.value.claseContratoId, classContract.value, () => {
          addingClassContract.value = false
          router.push({ name: 'apps-human-resources-class-contract-list' })
        })
      }
    }

    return {
      classContract,
      addingClassContract,
      required,
      getValidationState,
      refFormObserver,
      resetForm,
      onSubmit,

    }
  },
}
</script>
